import Component from 'flarum/common/Component';
const ADSENSE_CLIENT = 'ca-pub-5329779135859579';
const ADSENSE_SLOT = '8861080332';

/**
 * Exact ad sizes, chosen BEFORE making the AdSense request. Google permits
 * these sizes as a documented modified-responsive display-ad pattern.
 * We also check the actual discussion-column width before requesting an ad;
 * a narrower Flarum column must not overflow its container.
 */
function chooseAdSize(availableWidth, viewportWidth) {
  if (viewportWidth >= 800 && availableWidth >= 728) return {
    width: 728,
    height: 90
  };
  if (viewportWidth >= 500 && availableWidth >= 468) return {
    width: 468,
    height: 60
  };
  if (availableWidth >= 320) return {
    width: 320,
    height: 100
  };
  return null;
}
export default class DiscussionAd extends Component {
  oncreate(vnode) {
    this.initializeAd(vnode.dom);
  }
  initializeAd(root) {
    try {
      const ad = root?.querySelector?.('.adsbygoogle');
      const inner = root?.querySelector?.('.PinoyTalksDiscussionAd__inner');
      if (!ad || !inner || ad.dataset.pinoytalksInitialized === '1') return;

      // A responsive AdSense unit must have its final dimensions before push.
      const available = Math.floor(inner.getBoundingClientRect().width);
      const viewport = window.innerWidth || document.documentElement.clientWidth;
      const size = chooseAdSize(available, viewport);
      if (!size) {
        // A column smaller than 320px cannot safely contain this ad.
        // Never crop, squeeze, or request an ad that will overflow.
        root.style.display = 'none';
        return;
      }
      ad.style.width = `${size.width}px`;
      ad.style.height = `${size.height}px`;
      inner.style.minHeight = `${size.height}px`;
      ad.dataset.pinoytalksInitialized = '1';
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch (error) {
      // Never interrupt discussion rendering because of AdSense.
    }
  }
  view() {
    const postNumber = this.attrs.postNumber;
    return m("div", {
      className: "PinoyTalksDiscussionAd",
      "data-pinoytalks-ad-after-post": postNumber,
      role: "complementary",
      "aria-label": "Advertisement"
    }, m("div", {
      className: "PinoyTalksDiscussionAd__label"
    }, "Advertisement"), m("div", {
      className: "PinoyTalksDiscussionAd__inner"
    }, m("ins", {
      className: "adsbygoogle PinoyTalks_discussion_ads_unit",
      style: {
        display: 'block'
      },
      "data-ad-client": ADSENSE_CLIENT,
      "data-ad-slot": ADSENSE_SLOT
    })));
  }
}
flarum.reg.add('pinoytalks-discussion-ads', 'forum/components/DiscussionAd', DiscussionAd);